import React from 'react'
import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardText,
    FormGroup,
    Form,
    Input,
    Row,
    Col
} from "reactstrap";
import firebase from "../../firebase/firebase-config";

import { toast, Toast, ToastContainer } from 'react-toastify';
function SingleReportCase() {
    const params = useParams();

    const [reportData, setreportData] = useState({})
    const [case_status, setcase_status] = useState({ status: 'Solved' });
    const [reportObject, setReportObject] = useState([]);
    const [reportImititationObject, setreportImititationObject] = useState([]);
    const [immitationUser, setImmitationUser] = useState({});
    const [case_status_update, setcase_status_update] = useState({ status: case_status.status });


    const getReportData = async () => {
        await firebase.firestore().collection('reports').doc(params.id).onSnapshot((reportDt) => {

            setreportData(reportDt.data());
            // setReportObject([])
            const postObj = reportDt.data()['postObject'];
            console.log(Object.keys(postObj).length, 'this i postObjsuserm');
            console.log(postObj);
            if ((Object.keys(postObj).length == 0) === true) {

            } else {
                setReportObject([reportDt.data()['postObject']])
            }
            const userIm = reportDt.data()['imitationObject'];
            console.log(Object.keys(userIm).length, 'this i suserm');
            console.log(userIm);
            if ((Object.keys(userIm).length == 0) == true) {

            } else {
                getUserDetails(userIm.userId);
                setreportImititationObject([reportDt.data()['imitationObject']])
            }


            // console.log();

        })

    }
    const getUserDetails = async (uid) => {
        await firebase.firestore().collection('users').doc(uid).onSnapshot((data) => {

            setImmitationUser(data.data());
        })

    }
    const setCurrentCaseStatus = () => {
        var casses_status = '';
        firebase.firestore().collection('reports').doc(params.id).onSnapshot((snapshot) => {

            casses_status = snapshot.data()['caseStatus'];

            setcase_status({ status: casses_status });
        });
    }
    useEffect(() => {
        getReportData();
        setCurrentCaseStatus();
    }, []);
    const case_statuses = [

        {

            label: "Solved",

            value: "Solved",

        },

        {

            label: "UnSolved",

            value: "unSolved",

        },




    ];
    const changeCaseStatus = async () => {
        console.log(case_status_update)



        await firebase.firestore().collection('reports').doc(params.id).update({
            'caseStatus': case_status_update.status
        }).then((e) => {

            toast.success(`Case Status Has been updated to  ${case_status_update.status}`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            })
        });



    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="8" className="shadow-lg  rounded">
                        <Card>
                            <CardHeader>
                                <h5 className="title display-4">Report Case</h5>
                                <h5 className="title display-5">Report Case No : {reportData.uniqueId}</h5>
                                <h5>Report Created On : </h5>
                                <div className='d-flex'>
                                    <h5>Report Type:</h5>
                                    <div className='d-flex justify-content-center   mb-4 '>
                                        <p className='ml-3 bg-danger px-3 py-2 rounded'>{reportData.reportType} / {reportData.type}</p>
                                    </div>
                                </div>


                            </CardHeader>
                            <CardBody>

                                {(Object.keys(reportObject).length == 0) == true ?

                                    ""
                                    :

                                    reportObject?.map((pd) => {

                                        return <div className="description" style={{ overflow: 'scroll', height: '200px' }}>Objects :
                                            <Link to={`/admin/Total-Products/Single-Product/${pd.id}`} ><div key={pd.id} className="my-2 ">
                                                <div className="d-flex justify-content-between shadow-lg border rounded p-2">
                                                    <div className="d-flex ">
                                                        <div style={{ height: '50px' }}>
                                                            <img src={pd.media} className="image-fluid" style={{ height: '100%', width: '100%' }} />
                                                        </div>
                                                        <div className="px-3">
                                                            <h5 className=" font-weight-bolder ">{pd.title}</h5>
                                                            <p className="  ">{pd.description}</p>

                                                            <div className="d-flex justify-content-between">


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </Link>
                                        </div>
                                    })
                                }



                                {reportImititationObject?.length == 0 ?
                                    ""

                                    :
                                    <div>
                                        Imitation Objects :
                                        <Link to={`/admin/total-beyown-users/single_user/${immitationUser.id}`} ><div key={immitationUser?.id} className="my-2 ">
                                            <div className="d-flex justify-content-between shadow-lg border rounded p-2">
                                                <div className="d-flex ">
                                                    <div style={{ height: '50px' }}>
                                                        <img src={immitationUser?.profilePicture} className="image-fluid" style={{ height: '100%', width: '100%' }} />
                                                    </div>
                                                    <div className="px-3">
                                                        <h5 className=" font-weight-bolder ">@{immitationUser?.username}</h5>
                                                        <p className="  ">{immitationUser?.fullName}</p>

                                                        <div className="d-flex justify-content-between">


                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        </Link>
                                    </div>

                                }






                                <p>Current Status : {case_status?.status == 'Solved' ? 'Solved' : case_status?.status == 'unSolved' ? 'Unsolved' : ""}</p>
                                <FormGroup>
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        <select className="custom-select mt-3 text-info" value={case_status_update.status} onChange={(e) => { setcase_status_update({ status: e.target.value }) }} >

                                            {case_statuses.map((status) => {
                                                return <option className='text-info' value={status.value} >{status.label}</option>
                                            })}
                                        </select>

                                        <button className="btn btn-sm mt-3  btn-secondary" type="button" onClick={changeCaseStatus}>Change Status</button>
                                    </div>

                                </FormGroup>
                            </CardBody>


                        </Card>
                    </Col>
                    <Col md="4">
                        <Row className='mx-2'>
                            <Card className="card-user shadow-lg">


                                <div className="Single_author">
                                    <div className="block block-one" />
                                    <div className="block block-two" />
                                    <div className="block block-three" />
                                    <div className="block block-four" />
                                    <div className="d-flex justify-content-between  " >
                                        <div className=" d-flex ">
                                            <img
                                                alt="..."
                                                className="avatar_single_user"
                                                src={reportData?.reportUserProfilePic}
                                            />

                                            <div className="ml-2 mt-2">
                                                <div className='d-flex'>
                                                    <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{reportData.reportByName}</p>
                                                </div>

                                            </div>

                                        </div>
                                        <p className="description text-white m-2" style={{ fontSize: '14px' }}>Beyown user</p>


                                    </div>



                                </div>




                            </Card>
                        </Row>
                        <div className='d-flex justify-content-center  mb-4 '>
                            <p className='bg-danger px-3 py-2 rounded'>Reported</p>
                        </div>
                        <Row className='mx-2'>
                            <Card className="card-user shadow-lg">

                                <div className="Single_author">
                                    <div className="block block-one" />
                                    <div className="block block-two" />
                                    <div className="block block-three" />
                                    <div className="block block-four" />
                                    <div className="d-flex justify-content-between  " >
                                        <div className=" d-flex ">
                                            <img
                                                alt="..."
                                                className="avatar_single_user"
                                                src={reportData.userReportedProfilePic}
                                            />

                                            <div className="ml-2 mt-2">
                                                <div className='d-flex'>
                                                    <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{reportData.userReportedName}</p>
                                                </div>

                                            </div>

                                        </div>
                                        <p className="description  text-white m-2" style={{ fontSize: '14px' }}>Beyown user</p>


                                    </div>



                                </div>



                            </Card>
                        </Row>

                    </Col>
                </Row>
            </div >
            <ToastContainer />

        </>
    )
}

export default SingleReportCase